/**
 *
 * Subscriptions
 *
 */

import React, { memo, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';

import {
  initRedirectionForm,
  // setActiveNavigation,
  checkIframeLoaded,
} from 'utils/common';
import {
  SUBSCRIPTIONS_IFRAME_CONFIG,
  TEST,
  NAVIGATION_BAR_OPTIONS,
  TEST_WEBHOOK,
  BULK_CREATE_SUBSCRIPTIONS,
  IMPORT_MANDATES,
} from 'utils/constants';

import { selectSubscriptionsConfigSelector } from '../DashboardContainer/selectors';
import Loader from '../../components/Loader';

export function Subscriptions({
  menuSelected,
  subscriptionsConfig,
  activeNavigation,
}) {
  const [isLoading, resetLoader] = useState(true);
  // const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // eslint-disable-next-line no-unused-vars
  let navigationOptions = NAVIGATION_BAR_OPTIONS[menuSelected];

  navigationOptions = navigationOptions.filter(obj => {
    if (obj.text === BULK_CREATE_SUBSCRIPTIONS)
      return !!subscriptionsConfig.bulkSubscriptionEnabled;
    if (obj.text === IMPORT_MANDATES)
      return !!subscriptionsConfig.mandatePortingEnabled;
    if (obj.text === TEST_WEBHOOK) return searchParams.get('env') === TEST;
    return true;
  });

  const { title, key } = SUBSCRIPTIONS_IFRAME_CONFIG[activeNavigation];

  function afterLoading() {
    resetLoader(false);
  }

  useEffect(() => {
    setTimeout(() => {
      initRedirectionForm(searchParams.get('env') === TEST, key, {
        target: key,
        iframe: 1,
      });
      checkIframeLoaded(key, afterLoading);
    }, 0);
  }, [activeNavigation, searchParams.get('env')]);

  // const handleNavigationClick = (e, { name }) => {
  //   resetLoader(true);
  //   setActiveNavigation(name, history, navigationOptions);
  // };

  return (
    <div className="subscriptions-container">
      <Loader active={isLoading} />
      {/* <NavigationBar
        navigationOptions={navigationOptions.map(({ text }) => text)}
        activeNavigation={activeNavigation}
        handleNavigationClick={handleNavigationClick}
      /> */}
      <div>
        <iframe
          id={key}
          name={key}
          key={key}
          className="subscriptions-iframe"
          title={title}
          src=""
        />
      </div>
    </div>
  );
}

Subscriptions.propTypes = {
  menuSelected: PropTypes.string.isRequired,
  subscriptionsConfig: PropTypes.object.isRequired,
  activeNavigation: PropTypes.string,
};

const mapStateToProps = createStructuredSelector({
  subscriptionsConfig: selectSubscriptionsConfigSelector(),
});

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withConnect,
  memo,
)(Subscriptions);
